export default {
  date_picker: {
    ok: 'OK',
    cancel: 'Cancelar'
  }
}
